export const FormatString = {
  emailPattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  date: "dd/MM/yyyy",
  dateLong: "dd MMMM yyyy",
  duration: "HH:mm",
  time: "h:mm a",
  timeLong: "h:mm:ss a",
  timeSpan: "HH:mm:ss",
  dateTime: (): string => { return `${FormatString.date} ${FormatString.time}` },
  dateTimeLong: (): string => { return `${FormatString.dateLong}, ${FormatString.timeLong}` },
  metricDecimal: "1.2-2",

  bryntumDate: "DD/MM/YYYY",
  bryntumDateTime: (): string => { return `${FormatString.bryntumDate} ${FormatString.bryntumTime}` },
  bryntumDateTime24h: (): string => { return `${FormatString.bryntumDate} ${FormatString.bryntumTime24h}` },
  bryntumTime: "H:mm A",
  bryntumTime24h: "HH:mm",
  bryntumHour: "hA",
  bryntumMinute: "mm",

}
